var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningAmberBlack(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.58048L40.2755 34.4138H4.72449L22.5 4.58048ZM0.640606 32.1207C-1.17708 35.1705 1.08912 39 4.72449 39H40.2755C43.9109 39 46.1771 35.1705 44.3594 32.1207L26.5839 2.28737C24.7662 -0.762458 20.2338 -0.762458 18.4161 2.28737L0.640606 32.1207ZM20.1394 16.0689V20.6552C20.1394 21.9164 21.2017 22.9483 22.5 22.9483C23.7983 22.9483 24.8606 21.9164 24.8606 20.6552V16.0689C24.8606 14.8077 23.7983 13.7758 22.5 13.7758C21.2017 13.7758 20.1394 14.8077 20.1394 16.0689ZM20.1394 27.5345H24.8606V32.1207H20.1394V27.5345Z",
    fill: "#DC0000"
  })));
}

export default SvgWarningAmberBlack;